module.exports = "//public.getcloudapp.com/packs/media/images/apple_logo-4aa76b6c6552cfb1c1fa13ca85317181.svg";